import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Menu,
  Grid,
  Form,
  Button,
  Input,
  Dropdown,
  Tab,
  Message,
  Modal,
} from "semantic-ui-react";
import DataLayerModal from "./DataLayerModal";
import styles from "./DataConnections.module.css";
import DatabaseListing from "./DatabaseListing";
import { DataProvider } from "./DataProvider";
import axios from "axios"; // For making API requests
import dataconnection from "../../../api/DataConnection/dataconnection";
import ConnectionList from "./ConnectionList";
import { DataContext } from "./DataProvider";

const authOptions = [
  { key: "none", value: "none", text: "None" },
  { key: "bearer", value: "bearer", text: "Bearer Token" },
  { key: "basic", value: "basic", text: "Basic Auth" },
  { key: "apikey", value: "apikey", text: "Api Key" },
];

const Dataconnectionwrapper = () => {
  const { toolapiendpoint, loadToolApiendpoint, connections } =
    useContext(DataContext);
  const topRef = useRef(null); // Create a ref for the scroll target
  // State declarations with corrected naming
  const [timeInSWC, setTimeInSWC] = useState("");
  const [showConnectionform, setShowConnectionform] = useState(true);
  const [activeTab, setActiveTab] = useState("params");
  const [modalStatus, setmodalStatus] = useState(false);
  const [databases, setDatabases] = useState([]);
  const [selectedAuthType, setSelectedAuthType] = useState("none");
  const [selectedBodyType, setSelectedBodyType] = useState("formdata");
  const [initFormdata, setinitFormdata] = useState({});
  const [keyValuePairs, setKeyValuePairs] = useState([{ key: "", value: "" }]);
  const [operation, setOperation] = useState("add");
  const [rawBody, setRawBody] = useState("{}");
  const [responseOutput, setResponseOutput] = useState(null);
  const [method, setMethod] = useState("get"); // HTTP method
  const [endpointUrl, setEndpointUrl] = useState("");
  const [headers, setHeaders] = useState([{ key: "", value: "" }]); // Dynamic headers
  const [paramskeyValuePairs, setParamKeyValuePairs] = useState([
    { key: "", value: "" },
  ]);
  // States for mapping response in settings
  const [databaseColumns, setDatabaseColumns] = useState([]); // Example database columns
  const [availableKeys, setAvailableKeys] = useState([]); // Keys from the response tab
  // Initialize mappings with default empty values for each column
  const [mappings, setMappings] = useState({});
  const [defaultMappings, setDefaultMappings] = useState({}); // Corrected from defualtMappings
  // Usage example
  const [selectedDatabase, setSelectedDatabase] = useState(null);
  const [errorMessage, setErrorMessage] = useState(""); // Error message state
  const [errorMessageType, setErrorMessageType] = useState("warning"); // Error message state
  const [dbloaderSatus, setDbloaderStatus] = useState(true);
  const [conloaderSatus, setConloaderStatus] = useState(true);
  const [availableDatabases, setAvailableDatabases] = useState([]);
  const [availableKeyCopy, setAvailableKeyCopy] = useState([]); // Corrected from avaialbeKeycopy
  const [veriable, setveriable] = useState([]);
  const [editMode, setEditMod] = useState(false);
  const [changeUrl, setChangeUrl] = useState("No");
  const [authConfig, setAuthConfig] = useState({
    id: null,
    endpoint_name: "",
    type: "none",
    username: "",
    password: "",
    token: "",
    apiKey: {
      key: "",
      value: "",
      place: "header",
    },
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [customValue, setCustomValue] = useState("");
  const [timeUnit, setTimeUnit] = useState("");
  const inputRef = useRef(null);
  const variableOptions = [{ key: "now", text: "NOW", value: "NOW" }];
  const timeUnitOptions = [
    { key: "minute", text: "Minute", value: "MINUTE" },
    { key: "day", text: "Day", value: "DAY" },
    { key: "month", text: "Month", value: "MONTH" },
  ];

  // Handle text selection in textarea
  const getSelectedText = () => {
    const input = inputRef.current;
    const selection = window.getSelection();
    const selected = selection.toString().trim();

    if (input && selected) {
      if (selected !== "") {
        setSelectedText(selected);
        setModalOpen(true);
      }
    }
  };

  // Handle text replacement
  const handleReplace = () => {
    if (dropdownValue && selectedText) {
      // Replace in textarea
      let replacementValue = "";
      if (dropdownValue === "CURRENT_TIMESTAMP") {
        replacementValue = `{{${dropdownValue}}}`;
      } else {
        replacementValue = `{{${dropdownValue}_PLUS_${customValue}_${timeUnit}}}`;
      }
      const newValue = endpointUrl.replace(selectedText, replacementValue);
      setEndpointUrl(newValue);
    }
    setModalOpen(false);
    setDropdownValue("");
    setSelectedText("");
    setCustomValue("");
    setTimeUnit("");
  };

  const setDbloaderStatusp = (status) => {
    setDbloaderStatus(status);
  };

  // Render database selection
  const renderDatabaseSelection = (selectedDatabase, handleDatabaseChange) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <label
          style={{ marginRight: "10px", fontWeight: "bold", minWidth: "120px" }}
        >
          Select Database:
        </label>
        <Dropdown
          placeholder="Select Database"
          selection
          options={availableDatabases}
          value={selectedDatabase}
          onChange={(e, { value }) => handleDatabaseChange(e, { value })} // Handle database selection
          style={{ flex: 1, paddingLeft: "1rem" }}
        />
      </div>
    );
  };

  // Function to handle the change when a database is selected
  const handleDatabaseChange = (e, { value }) => {
    const selectedDb = availableDatabases.find((db) => db.value === value);
    setSelectedDatabase(value); // Set the selected database in the state
    // Set the columns of the selected database
    setDatabaseColumns(selectedDb ? selectedDb.columns : []);
    // Reset mappings
    setMappings({});
    setDefaultMappings({}); // Corrected from setdefualtMappings

    // Extract and set available keys
    let extractedKeys = [];
    if (endpointUrl.includes("sheets.googleapis.com")) {
      extractedKeys = extractKeysFromResponseForSheet(responseOutput);
    } else {
      const newfirstValidValue = Object.values(responseOutput).find(
        (val) => Array.isArray(val) && val.length > 0
      );
      extractedKeys = extractKeysFromResponse(newfirstValidValue ?? []);
    }
    setAvailableKeys(extractedKeys);
    return;
  };

  // Function for mapping table column and response keys
  const handleMapping = (column, selectedKey) => {
    setMappings((prevMappings) => {
      console.log(prevMappings, "prevMappings");
      const previousKey = prevMappings[column];
      const updatedMappings = { ...prevMappings, [column]: selectedKey };
      if (previousKey && previousKey !== selectedKey) {
        setAvailableKeys((prevKeys) =>
          prevKeys.filter((keyav) => keyav !== column)
        );
      }
      return updatedMappings;
    });
    setAvailableKeys((prevKeys) =>
      prevKeys.filter((key) => key !== selectedKey)
    );
  };

  // Corrected function name from handleDefualtMapping to handleDefaultMapping
  const handleDefaultMapping = (column, default_value) => {
    setDefaultMappings((prevMappings) => {
      console.log(prevMappings, "prevMappings");
      const previousKey = prevMappings[column];
      const updatedMappings = { ...prevMappings, [column]: default_value };
      if (previousKey && previousKey !== default_value) {
        setAvailableKeys((prevKeys) =>
          prevKeys.filter((keyav) => keyav !== column)
        );
      }
      return updatedMappings;
    });
    setAvailableKeys((prevKeys) =>
      prevKeys.filter((key) => key !== default_value)
    );
  };

  function extractKeysFromResponse(obj, parentKey = "", keys = new Set()) {
    console.log("extractKeys", obj);
    if (typeof obj === "object" && obj !== null) {
      if (Array.isArray(obj)) {
        obj.forEach((item) => {
          extractKeysFromResponse(item, parentKey, keys);
        });
      } else {
        Object.entries(obj).forEach(([key, value]) => {
          const fullKey = parentKey ? `${parentKey}.${key}` : key;
          keys.add(fullKey);
          extractKeysFromResponse(value, fullKey, keys);
        });
      }
    }
    return Array.from(keys);
  }

  // Rendering settings mapping stuff
  const renderSettingsItems = (
    databaseColumns,
    availableKeys,
    handleMapping,
    mappings,
    defaultMappings, // Corrected parameter name
    handleDefaultMapping // Corrected parameter name
  ) => {
    return (
      <div style={{ marginTop: "20px" }}>
        <div style={{ marginTop: "10px" }}>
          <label>Time in SWC</label>
          <Input
            placeholder="Time in SWC"
            value={timeInSWC}
            onChange={(e) => {
              const value = e.target.value;
              setTimeInSWC(value);
            }}
          />
          <br />
          <small style={{ color: "orange" }}>
            Sample: If the value is 1, use rate(minute/hour). If the value is greater than 1, use rate(minutes/hours).
          </small>
        </div>
        <div style={{ marginTop: "20px" }}>
          <label style={{ marginRight: "10px" }}>Operation</label>
          <Dropdown
            placeholder="Select Operation"
            selection
            options={[
              { key: "MERGE", value: "merge", text: "Merge" },
              { key: "REPLACE", value: "replace", text: "Replace" },
              { key: "APPEND", value: "append", text: "Append" },
            ]}
            value={operation}
            onChange={(e, { value }) => setOperation(value)}
            style={{ paddingLeft: "1rem" }}
          />
        </div>
        <h4>Map Database Columns to Response Keys</h4>
        {editMode
          ? Array.from(databaseColumns).map((column, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <label
                  style={{
                    marginRight: "10px",
                    fontWeight: "bold",
                    minWidth: "100px",
                  }}
                >
                  {column}
                </label>
                <Dropdown
                  placeholder={mappings[column] ?? ""}
                  selection
                  options={[
                    { key: "default", text: "Select...", value: "" },
                    ...availableKeys.map((key, index) => ({
                      index,
                      text: key,
                      value: key,
                    })),
                  ]}
                  value={mappings[column] ?? ""}
                  onChange={(e, { value }) => handleMapping(column, value)}
                  style={{ flex: 1, paddingLeft: "1rem" }}
                />
                <Input
                  placeholder="Default value" // Corrected typo
                  value={defaultMappings[column] ?? ""} // Corrected state name
                  onChange={(e) => handleDefaultMapping(column, e.target.value)} // Corrected function name
                  style={{ width: "30%" }}
                />
              </div>
            ))
          : ""}
      </div>
    );
  };

  useEffect(() => {
    if (connections != undefined) {
      let listofdb = connections ?? [];
      console.log("databases updated eeee", connections);
      setDatabases(listofdb);
    }
  }, [connections]);

  // Updated to store headers as an array of objects
  useEffect(() => {
    console.log("database changes", databases);
    if (connections != undefined) {
      let avdb = databases.map((db) => {
        let colm = JSON.parse(db.columns);
        return {
          key: db.id,
          text: db.name,
          value: db.id,
          columns: colm.map((col) => {
            return col.name;
          }), // Columns for Database
        };
      });
      setAvailableDatabases(avdb);
    }
  }, [databases, dbloaderSatus, modalStatus]);

  const handleAuthTypeChange = (e, { value }) => {
    setSelectedAuthType(value);
    setAuthConfig((prev) => ({ ...prev, type: value }));
  };

  // Handle changes for API Key
  const handleKeyChange = (e) => {
    const newKey = e.target.value;
    setAuthConfig((prev) => ({
      ...prev,
      apiKey: { ...prev.apiKey, key: newKey },
    }));
  };

  const handleValueChange = (e) => {
    const value = e.target.value;
    setAuthConfig((prev) => ({
      ...prev,
      apiKey: { ...prev.apiKey, value: value },
    }));
  };

  const handlePlaceChange = (e, { value }) => {
    const place = value; // Corrected from e.target.value
    setAuthConfig((prev) => ({
      ...prev,
      apiKey: { ...prev.apiKey, type: place },
    }));
  };

  // Handle changes for username
  const handleUsernameChange = (e) => {
    const value = e.target?.value;
    setAuthConfig((prev) => ({
      ...prev,
      username: value,
    }));
  };

  // Handle changes for password
  const handlePasswordChange = (e) => {
    const value = e.target?.value;
    setAuthConfig((prev) => ({
      ...prev,
      password: value,
    }));
  };

  // Handle changes for Bearer Token
  const handleTokenChange = (e) => {
    const value = e.target?.value;
    setAuthConfig((prev) => ({
      ...prev,
      token: value,
    }));
  };

  // Create a function to set error message with timeout
  const setErrorMessageWithTimeout = (message, type = "warning") => {
    setErrorMessageType(type);
    setErrorMessage(message);
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setTimeout(() => {
      setErrorMessage("");
    }, 5000);
  };

  // Reset form for connection
  const resetCOnnectform = () => {
    setEndpointUrl("");
    setMappings([]);
    setDefaultMappings([]); // Corrected
    setSelectedDatabase("");
    setMethod("get");
    setHeaders([]);
    setSelectedAuthType("none");
    setRawBody("{}");
    setSelectedBodyType("formdata");
    setAuthConfig({
      id: null,
      endpoint_name: "",
      type: "none",
      username: "",
      password: "",
      token: "",
      apiKey: {
        key: "",
        value: "",
        place: "header",
      },
    });
    setTimeInSWC("");
  };

  // Create URL with search parameters
  function addParamsToUrl(endpoint, params) {
    let paramsname = "";
    params.forEach((param) => {
      if (param.key && param.value) {
        paramsname = paramsname + `${param.key}=${param.value}&`;
      }
    });
    if (paramsname != "") {
      endpoint = endpoint.endsWith("/") ? endpoint.slice(0, -1) : endpoint;
      endpoint = endpoint + "?" + paramsname;
    }
    setEndpointUrl(endpoint);
    return endpoint.toString();
  }

  // Function to save data connection
  const handleSaveConnection = () => {
    if (method == "get") {
      addParamsToUrl(endpointUrl, paramskeyValuePairs);
    }

    const timestampUrl = processEndpointUrl(endpointUrl);
    const payload = {
      endpointName: authConfig.endpoint_name,
      endpointUrl: timestampUrl,
      displayUrl: changeUrl === "Yes" ? endpointUrl : null,
      authorization: {
        type: selectedAuthType,
        token:
          headers.find((header) => header.key === "Authorization")?.value || "",
      },
      headers: headers,
      body: {
        type: selectedBodyType,
        data: selectedBodyType === "formdata" ? keyValuePairs : rawBody,
      },
      mapping: mappings,
      mappingDefault: defaultMappings, // Corrected
      method: method,
      authConfig: authConfig,
      selectedDatabase: selectedDatabase,
      timeInSWC: timeInSWC,
      params: paramskeyValuePairs,
      operation: operation,
      availableKeyCopy: availableKeyCopy, // Corrected
    };
    const pattern = /^rate\((\d+)\s+(hour|hours|minute|minutes)\)$/;
    const match = timeInSWC.match(pattern);
    if (!match) {
      setErrorMessageWithTimeout("Invalid format of Time in SWC", "error");
      return;
    }
    const number = parseInt(match[1], 10);
    const unit = match[2];
    // Check if singular/plural matches the number
    if (number === 1 && (unit === 'hours' || unit === 'minutes')) {
      setErrorMessageWithTimeout("Invalid format of Time in SWC: Use singular form for 1 (e.g., '1 minute' or '1 hour')", "error");
      return;
    }
    if (number > 1 && (unit === 'hour' || unit === 'minute')) {
      setErrorMessageWithTimeout("Invalid format of Time in SWC: Use plural form for numbers greater than 1 (e.g., '5 minutes' or '24 hours')", "error");
      return;
    }

    
    setAvailableKeyCopy({}); // Corrected
    setEditMod(false);

    if (authConfig?.id == null) {
      setConloaderStatus(true);
      dataconnection.addDataApiConnection(payload).then((res) => {
        let st = res?.status ?? "";
        if (st == "success") {
          loadToolApiendpoint();
          resetCOnnectform();
          setChangeUrl("No");
          setErrorMessageWithTimeout(
            res?.message ?? "Data added successfully.",
            res.status ?? "success"
          );
        } else {
          let error_list = res?.errors ?? {};
          setChangeUrl("No");
          setErrorMessageWithTimeout(
            res?.message ?? "All form data must be filled!",
            res.status
          );
        }
        setConloaderStatus(false);
      });
    } else {
      // Step 3: Prepare the JSON payload (already created above)
      dataconnection
        .editDataApiConnection(authConfig?.id, payload)
        .then((res) => {
          if (res) {
            setErrorMessageWithTimeout(
              res?.message ?? "Data modified successfully.",
              res.status
            );
            loadToolApiendpoint();
            resetCOnnectform();
            setConloaderStatus(false);
          } else {
            setErrorMessageWithTimeout(
              "Please refresh page and try again",
              "error"
            );
            setConloaderStatus(false);
          }
        });
    }
  };

  // Render auth fields
  const renderAuthFields = () => {
    return (
      <div style={{ minHeight: "160px" }}>
        {selectedAuthType === "none" && (
          <p>
            The authorization header will be automatically generated when you send
            the request.
          </p>
        )}
        {selectedAuthType === "basic" && (
          <>
            <Form.Field>
              <label>Username</label>
              <Input
                placeholder="Enter Username"
                value={authConfig.username}
                onChange={handleUsernameChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Password</label>
              <Input
                placeholder="Enter Password"
                type="password"
                value={authConfig.password}
                onChange={handlePasswordChange}
              />
            </Form.Field>
          </>
        )}
        {selectedAuthType === "bearer" && (
          <Form.Field>
            <label>Bearer Token</label>
            <Input
              placeholder="Enter Bearer Token"
              value={authConfig?.token}
              onChange={handleTokenChange}
            />
          </Form.Field>
        )}
        {selectedAuthType === "apikey" && (
          <>
            <Form.Field>
              <label>Key</label>
              <Input
                placeholder="Enter API Key"
                value={authConfig.apiKey.key}
                onChange={handleKeyChange}
              />
            </Form.Field>
            <Form.Field>
 SWEET              <label>Value</label>
              <Input
                placeholder="Enter Value"
                value={authConfig.apiKey.value}
                onChange={handleValueChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Place</label>
              <Dropdown
                placeholder="Select Place"
                fluid
                selection
                options={[
                  { key: "header", value: "header", text: "Header" },
                  { key: "param", value: "param", text: "Param" },
                ]}
                value={authConfig.apiKey.place} // Corrected from type to place
                onChange={handlePlaceChange}
              />
            </Form.Field>
          </>
        )}
      </div>
    );
  };

  const handleConvertToJson = (txt) => {
    try {
      setTimeout(() => {
        const jsonString = JSON.stringify(txt, null, 2); // Pretty print
        return jsonString;
      }, 0); // Defer to next event loop
    } catch (err) {
      return "Failed to convert log data to JSON";
    }
  };

  const renderResponsePanel = () => (
    <div>
      {responseOutput ? (
        <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          <Form.Field>
            <textarea
              readOnly
              style={{ height: "250px", width: "100%", resize: "vertical" }}
              value={JSON.stringify(responseOutput, undefined, 4)}
              id="resposeoutput"
            ></textarea>
          </Form.Field>
        </pre>
      ) : (
        <p>No response available. Click "Test" to fetch data.</p>
      )}
    </div>
  );

  const handleAddKeyValuePair = () => {
    setKeyValuePairs([...keyValuePairs, { key: "", value: "" }]);
  };

  // Remove Key-Value Pair
  const handleRemoveKeyValuePair = (index) => {
    setKeyValuePairs(keyValuePairs.filter((_, i) => i !== index));
  };

  // Update Key-Value Pair
  const handleKeyValueChange = (index, field, value) => {
    const updatedPairs = keyValuePairs.map((pair, i) =>
      i === index ? { ...pair, [field]: value } : pair
    );
    setKeyValuePairs(updatedPairs);
  };

  // Render Body Panel
  const renderBodyPanel = () => (
    <div>
      <Form>
        <Form.Field>
          <label>Body Type</label>
          <Form.Group>
            <Form.Radio
              label="Form Data"
              value="formdata"
              checked={selectedBodyType === "formdata"}
              onChange={(e, { value }) => setSelectedBodyType(value)}
            />
            <Form.Radio
              label="x-www-form-urlencoded"
              value="x-www-form-urlencoded"
              checked={selectedBodyType === "x-www-form-urlencoded"}
              onChange={(e, { value }) => setSelectedBodyType(value)}
            />
            <Form.Radio
              label="Raw"
              value="raw"
              checked={selectedBodyType === "raw"}
              onChange={(e, { value }) => setSelectedBodyType(value)}
            />
          </Form.Group>
        </Form.Field>

        {selectedBodyType === "raw" && (
          <Form.Field>
            <label>Raw JSON</label>
            <textarea
              placeholder="Enter JSON"
              style={{ height: "150px", width: "100%", resize: "vertical" }}
              value={rawBody}
              onChange={(e) => {
                const inputValue = e.target.value;
                setRawBody(inputValue);
                try {
                  JSON.parse(inputValue); // Validate JSON
                } catch {
                  console.error("Invalid JSON");
                }
              }}
            />
          </Form.Field>
        )}

        {(selectedBodyType === "formdata" ||
          selectedBodyType === "x-www-form-urlencoded") && (
          <Form.Field>
            <label>Key-Value Pairs</label>
            {renderKeyValuePairs()}
          </Form.Field>
        )}
      </Form>
    </div>
  );

  // Render Key-Value Pairs
  const renderKeyValuePairs = () => (
    <>
      {keyValuePairs.map((pair, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Input
            placeholder="Key"
            value={pair.key}
            onChange={(e) => handleKeyValueChange(index, "key", e.target.value)}
            style={{ marginRight: "10px" }}
          />
          <Input
            placeholder="Value"
            value={pair.value}
            onChange={(e) =>
              handleKeyValueChange(index, "value", e.target.value)
            }
            style={{ marginRight: "10px" }}
          />
          {keyValuePairs.length > 1 && (
            <Button
              icon="minus"
              color="red"
              onClick={() => handleRemoveKeyValuePair(index)}
              style={{ marginRight: "10px" }}
            />
          )}
        </div>
      ))}
      <Button icon="plus" color="green" onClick={handleAddKeyValuePair} />
    </>
  );

  function extractKeysFromResponseForSheet(response) {
    let copy = {};
    let count = 0;
    for (const element of response.values[0]) {
      copy[element] = count;
      count++;
    }
    setAvailableKeyCopy(copy); // Corrected
    return response.values[0];
  }

  const calculateTimestamp = (operation, value, unit) => {
    const now = new Date();
    let timestamp;

    switch (operation) {
      case "PLUS":
        if (unit === "DAY") {
          timestamp = new Date(now.getTime() + value * 24 * 60 * 60 * 1000);
        } else if (unit === "MINUTE") {
          timestamp = new Date(now.getTime() + value * 60 * 1000);
        } else if (unit === "MONTH") {
          timestamp = new Date(now.setMonth(now.getMonth() + value));
        }
        break;
      case "MINUS":
        if (unit === "DAY") {
          timestamp = new Date(now.getTime() - value * 24 * 60 * 60 * 1000);
        } else if (unit === "MINUTE") {
          timestamp = new Date(now.getTime() - value * 60 * 1000);
        } else if (unit === "MONTH") {
          timestamp = new Date(now.setMonth(now.getMonth() - value));
        }
        break;
      default:
        timestamp = now; // Default to current time
    }
    return Math.floor(timestamp.getTime() / 1000);
  };

  const processEndpointUrl = (url) => {
    const regex = /{{(.*?)}}/g;
    let matches = [];
    let match;
    while ((match = regex.exec(url)) !== null) {
      matches.push(match[1]);
    }
    const result = {
      start: {},
      end: {},
    };

    matches.forEach((item, index) => {
      const parts = item.split("_");
      const obj = {
        base: parts[0],
        operation: parts[1],
        value: parseInt(parts[2]),
        unit: parts[3],
      };

      if (index === 0) {
        setChangeUrl("Yes");
        result.start = obj;
      } else if (index === 1) {
        result.end = obj;
      }
    });

    let startTimeSetup = calculateTimestamp(
      result.start.operation,
      result.start.value,
      result.start.unit
    );
    let endTimeSetup = calculateTimestamp(
      result.end.operation,
      result.end.value,
      result.end.unit
    );

    let processedUrl = url;
    processedUrl = processedUrl.replace(
      "{{" + matches[0] + "}}",
      startTimeSetup
    );
    processedUrl = processedUrl.replace("{{" + matches[1] + "}}", endTimeSetup);
    return processedUrl;
  };

  // Function to hit the API
  const handleTestEndpoint = async () => {
    if (!endpointUrl) {
      setErrorMessageWithTimeout("Please enter a valid Endpoint URL.");
      return;
    }

    let backupendpointUrl = endpointUrl;
    try {
      const processedUrl = processEndpointUrl(endpointUrl);

      let requestData = {
        endpointUrl: processedUrl,
        method: method,
        headers,
        authConfig: authConfig,
        selectedAuthType: selectedAuthType,
        bodyType: selectedBodyType,
        bodyData: keyValuePairs,
        params: paramskeyValuePairs,
        rawBody: rawBody ?? "{}",
      };
      const requestHeaders = {};
      if (selectedAuthType === "basic") {
        const authToken = btoa(`${authConfig.username}:${authConfig.password}`);
        requestHeaders["Authorization"] = `Basic ${authToken}`;
      } else if (selectedAuthType === "bearer") {
        requestHeaders["Authorization"] = `Bearer ${authConfig.token}`;
      } else if (
        selectedAuthType === "apikey" &&
        authConfig.apiKey.place === "header"
      ) {
        requestHeaders[authConfig.apiKey.key] = authConfig.apiKey.value;
      }

      headers.forEach(({ key, value }) => {
        if (key && value) {
          requestHeaders[key] = value;
        }
      });

      let requestBody = null;
      const urlencoded = new URLSearchParams();

      if (method === "get") {
        setEndpointUrl(addParamsToUrl(endpointUrl, paramskeyValuePairs));
      }

      dataconnection.testRequest(requestData).then((res) => {
        if (res.status) {
          setResponseOutput(res.data);
          setEndpointUrl(backupendpointUrl);
          setActiveTab("responses");
          let extractedKeys = [];
          if (endpointUrl.includes("sheets.googleapis.com")) {
            extractedKeys = extractKeysFromResponseForSheet(res.data);
          } else {
            const firstValidValue = Object.values(res.data).find(
              (val) => Array.isArray(val) && val.length > 0
            );
            extractedKeys = extractKeysFromResponse(firstValidValue ?? []);
          }
          extractedKeys = [...new Set(extractedKeys)];
          setEditMod(true);
          setAvailableKeys(extractedKeys);
        } else {
          setActiveTab("responses");
          setResponseOutput(res.message);
          setEndpointUrl(backupendpointUrl);
        }
      });
    } catch (error) {
      console.log(error);
      setActiveTab("responses 2");
      setResponseOutput(error.response || { error: error.message });
      setEndpointUrl(backupendpointUrl);
    }
  };

  // Render header management section
  const renderHeaderManagement = () => (
    <div>
      <h4>Manage Headers</h4>
      {headers.map((header, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Input
            placeholder="Key"
            value={header.key}
            onChange={(e) => handleHeaderChange(index, "key", e.target.value)}
            style={{ marginRight: "10px", flex: 1 }}
          />
          <Input
            placeholder="Value"
            value={header.value}
            onChange={(e) => handleHeaderChange(index, "value", e.target.value)}
            style={{ marginRight: "10px", flex: 1 }}
          />
          <Button
            icon="minus"
            color="red"
            onClick={() => handleRemoveHeader(index)}
            style={{ marginRight: "10px", width: "80px", padding: "5px" }}
          />
        </div>
      ))}
      <Button
        icon="plus"
        color="green"
        onClick={handleAddHeader}
        style={{ width: "100px", padding: "5px" }}
      />
    </div>
  );

  const setmodalStatusandcleardata = (status) => {
    setmodalStatus(status);
    setinitFormdata({});
  };

  // Header management
  const handleAddHeader = (type = "header") => {
    if (type === "params") {
      setParamKeyValuePairs([...paramskeyValuePairs, { key: "", value: "" }]);
    } else {
      setHeaders([...headers, { key: "", value: "" }]);
    }
  };

  const handleRemoveHeader = (index, type = "header") => {
    if (type === "params") {
      setParamKeyValuePairs(paramskeyValuePairs.filter((_, i) => i !== index));
    } else {
      setHeaders(headers.filter((_, i) => i !== index));
    }
  };

  // Update a specific header's key or value
  const handleHeaderChange = (index, field, value, type = "header") => {
    if (type === "params") {
      const updatedHeaders = paramskeyValuePairs.map((header, i) =>
        i === index ? { ...header, [field]: value } : header
      );
      setParamKeyValuePairs(updatedHeaders);
    } else {
      const updatedHeaders = headers.map((header, i) =>
        i === index ? { ...header, [field]: value } : header
      );
      setHeaders(updatedHeaders);
    }
  };

  const panes = [
    {
      menuItem: (
        <Menu.Item
          key="params"
          className={
            activeTab === "params" ? styles.menuActiveDataconnection : ""
          }
          onClick={() => setActiveTab("params")}
        >
          Params
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          <div>
            <h4>Manage Params</h4>
            {paramskeyValuePairs.map((header, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <Input
                  placeholder="Key"
                  value={header.key}
                  onChange={(e) =>
                    handleHeaderChange(index, "key", e.target.value, "params")
                  }
                  style={{ marginRight: "10px", flex: 1 }}
                />
                <Input
                  placeholder="Value"
                  value={header.value}
                  onChange={(e) =>
                    handleHeaderChange(index, "value", e.target.value, "params")
                  }
                  style={{ marginRight: "10px", flex: 1 }}
                />
                <Button
                  icon="minus"
                  color="red"
                  onClick={() => handleRemoveHeader(index, "params")}
                  style={{ marginRight: "10px", width: "80px", padding: "5px" }}
                />
              </div>
            ))}
            <Button
              icon="plus"
              color="green"
              onClick={() => handleAddHeader("params")}
              style={{ width: "100px", padding: "5px" }}
            />
          </div>
        </Tab.Pane>
      ),
    },
    {
      menuItem: (
        <Menu.Item
          key="authorization"
          className={
            activeTab === "authorization" ? styles.menuActiveDataconnection : ""
          }
          onClick={() => setActiveTab("authorization")}
        >
          Authorization
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          <Form>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {/* Left Section: Auth Type */}
              <div
                style={{
                  width: "40%",
                  borderRight: "1px solid rgb(190 202 213)",
                  paddingRight: "10px",
                }}
              >
                <Form.Field>
                  <label>Auth Type</label>
                  <Dropdown
                    placeholder="Select Auth Type"
                    fluid
                    selection
                    options={authOptions}
                    onChange={handleAuthTypeChange}
                    value={selectedAuthType}
                    style={{ paddingLeft: "1rem" }}
                  />
                </Form.Field>
              </div>
              <div style={{ width: "55%" }}>{renderAuthFields()}</div>
            </div>
          </Form>
        </Tab.Pane>
      ),
    },
    {
      menuItem: (
        <Menu.Item
          key="headers"
          onClick={() => setActiveTab("headers")}
          className={
            activeTab === "headers" ? styles.menuActiveDataconnection : ""
          }
        >
          Headers
        </Menu.Item>
      ),
      render: () => <Tab.Pane>{renderHeaderManagement()}</Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item
          key="body"
          className={
            activeTab === "body" ? styles.menuActiveDataconnection : ""
          }
          onClick={() => setActiveTab("body")}
        >
          Body
        </Menu.Item>
      ),
      render: () => <Tab.Pane>{renderBodyPanel()}</Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item
          key="responses"
          onClick={() => setActiveTab("responses")}
          className={
            activeTab === "responses" ? styles.menuActiveDataconnection : ""
          }
        >
          Responses
        </Menu.Item>
      ),
      render: () => <Tab.Pane>{renderResponsePanel()}</Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item
          key="settings"
          onClick={() => setActiveTab("settings")}
          className={
            activeTab === "settings" ? styles.menuActiveDataconnection : ""
          }
        >
          Settings
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          {renderDatabaseSelection(selectedDatabase, handleDatabaseChange)}
          {renderSettingsItems(
            databaseColumns,
            availableKeys,
            handleMapping,
            mappings,
            defaultMappings, // Corrected
            handleDefaultMapping // Corrected
          )}
        </Tab.Pane>
      ),
    },
  ];

  const onEditApiEndpont = (apicon) => {
    setActiveTab("settings");
    setResponseOutput(null);
    let operation = apicon.operation ?? "";
    setOperation(operation);
    let endpoint_url = apicon.endpoint_url ?? "";
    setEndpointUrl(endpoint_url);

    let mapping = apicon.mapping ?? "";
    let defaultMapping = apicon.mappingDefault ?? ""; // Corrected
    if (mapping) {
      setEditMod(true);
    }

    setMappings(mapping);
    setDefaultMappings(defaultMapping); // Corrected
    setSelectedDatabase(apicon.selectedDatabase ?? "");

    const selectedDb = availableDatabases.find(
      (db) => db.value === apicon.selectedDatabase
    );
    setDatabaseColumns(selectedDb ? selectedDb.columns : []);

    let method = apicon.method ?? "get";
    setMethod(method);
    let headers = apicon.headers ?? [];
    setHeaders(headers);
    let authorization_type = apicon.authorization_type ?? "none";
    if (authorization_type === "Bearer Token") {
      authorization_type = "bearer";
    }
    let params = apicon.params ?? [];
    setParamKeyValuePairs(params);

    setSelectedAuthType(authorization_type);
    if (apicon.body) {
      setSelectedBodyType(apicon.body.type || "formdata");
      if (apicon.body.type === "raw") {
        try {
          const parsedData = JSON.parse(apicon.body.data || "{}");
          setRawBody(JSON.stringify(parsedData, null, 2));
        } catch (error) {
          console.error("Invalid JSON in raw body data", error);
        }
      } else if (
        apicon.body.type === "formdata" ||
        apicon.body.type === "x-www-form-urlencoded"
      ) {
        const keyValuePairs = apicon.body.data;
        setKeyValuePairs(keyValuePairs);
      }
    }
    let authconn = apicon?.authConfig ?? authConfig;
    setAuthConfig(authconn);
    setAuthConfig((prev) => ({
      ...prev,
      id: apicon.id,
      endpoint_name: apicon.endpoint_name,
    }));
    setTimeInSWC(apicon?.timeInSWC ?? "");
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const buttonStyle = {
    background: "linear-gradient(90deg,rgb(241, 241, 241),rgb(212, 212, 212))",
    boxShadow: "0px 4px 8px #b3b3b3",
    borderRadius: "5px",
    color: "#333",
    display: "inline-block",
    fontSize: "16px",
    padding: "2px",
    textDecoration: "none",
    minWidth: "80px",
    border: 0,
  };

  return (
    <>
      <div ref={topRef}>
        <DataProvider>
          {showConnectionform && (
            <>
              {errorMessage &&
                (errorMessageType === "warning" ||
                errorMessageType === "error" ? (
                  <Message error>
                    <Message.Header>Validation Error</Message.Header>
                    <p>{errorMessage}</p>
                  </Message>
                ) : (
                  <Message success>
                    <Message.Header>Success message</Message.Header>
                    <p>{errorMessage}</p>
                  </Message>
                ))}
              <div style={{ padding: "40px" }}>
                <Form>
                  <Form.Field>
                    <Grid columns={2} stackable>
                      <label style={{ width: "30%" }}>Endpoint Name</label>
                      <Input
                        style={{ width: "69%" }}
                        placeholder="Endpoint name"
                        value={authConfig.endpoint_name}
                        onChange={(e) =>
                          setAuthConfig({
                            ...authConfig,
                            endpoint_name: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Form.Field>
                  <Form.Field>
                    <Grid columns={2} stackable style={{ marginTop: "2rem" }}>
                      <label style={{ width: "30%" }}>Endpoint URL</label>
                      <Input
                        placeholder="https://www.example.com"
                        ref={inputRef}
                        value={endpointUrl}
                        onChange={(e) => setEndpointUrl(e.target.value)}
                        onDoubleClick={getSelectedText}
                        style={{ width: "69%" }}
                        action={{
                          content: "Test",
                          color: "blue",
                          className: "btn linear-gradient",
                          style: { width: "15%", display: "block" },
                          onClick: handleTestEndpoint,
                        }}
                        label={
                          <Dropdown
                            placeholder="GET"
                            options={[
                              { key: "get", text: "GET", value: "get" },
                              { key: "post", text: "POST", value: "post" },
                              { key: "put", text: "PUT", value: "put" },
                              {
                                key: "delete",
                                text: "DELETE",
                                value: "delete",
                              },
                              { key: "patch", text: "PATCH", value: "patch" },
                            ]}
                            value={method}
                            onChange={(e, data) => {
                              const selectedValue = data.value;
                              setMethod(selectedValue);
                            }}
                            selection
                            style={{
                              minWidth: "80px",
                              width: "15%",
                              paddingLeft: "1rem",
                            }}
                          />
                        }
                        labelPosition="left"
                      />
                    </Grid>
                  </Form.Field>
                  {modalOpen && (
                    <div className="bg-white p-6 rounded-md w-96">
                      <h3 className="text-lg font-semibold mb-4">
                        Replace Selected Text
                      </h3>
                      <p className="mb-2">
                        Selected:{" "}
                        <span className="font-medium">"{selectedText}"</span>
                      </p>
                      <div className="d-flex gap-3">
                        <select
                          value={dropdownValue}
                          onChange={(e) => setDropdownValue(e.target.value)}
                          className="w-full p-2 border rounded-md mb-4"
                        >
                          <option value="" disabled>
                            Select a variable
                          </option>
                          {variableOptions.map((option) => (
                            <option key={option.key} value={option.value}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                        <input
                          type="number"
                          disabled={
                            dropdownValue !== "CURRENT_TIMESTAMP" ? false : true
                          }
                          placeholder="Enter custom value"
                          value={customValue}
                          onChange={(e) => setCustomValue(e.target.value)}
                          className={`w-full p-2 border rounded-md mb-4 ${
                            dropdownValue !== "CURRENT_TIMESTAMP"
                              ? "bg-gray-100 cursor-not-allowed"
                              : ""
                          }`}
                        />
                        <select
                          value={timeUnit}
                          disabled={
                            dropdownValue !== "CURRENT_TIMESTAMP" ? false : true
                          }
                          onChange={(e) => setTimeUnit(e.target.value)}
                          className={`w-full p-2 border rounded-md mb-4 ${
                            dropdownValue !== "{{CUSTOM_TIMESTAMP}}"
                              ? "bg-gray-100 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          <option value="" disabled>
                            Select a time unit
                          </option>
                          {timeUnitOptions.map((option) => (
                            <option key={option.key} value={option.value}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="d-flex justify-end gap-2">
                        <button
                          onClick={() => {
                            setModalOpen(false);
                            setDropdownValue("");
                            setSelectedText("");
                            setCustomValue("");
                            setTimeUnit("");
                          }}
                          className="btn-sm yr-btn-small"
                          style={buttonStyle}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleReplace}
                          className="btn linear-gradient yr-submitbtn btn-sm"
                          style={{ marginLeft: "10px" }}
                        >
                          Replace
                        </button>
                      </div>
                    </div>
                  )}
                </Form>
                <Tab
                  panes={panes}
                  style={{ marginTop: "2rem" }}
                  activeIndex={panes.findIndex(
                    (pane) => pane.menuItem.key === activeTab
                  )}
                />
              </div>
            </>
          )}
          {modalStatus && (
            <DataLayerModal
              open={modalStatus}
              onClose={() => setmodalStatus(false)}
              onOpen={() => setmodalStatus(true)}
              setDatabases={setDatabases}
              initFormdata={{ ...initFormdata }}
              selectedDatabase={selectedDatabase}
              setinitFormdata={setinitFormdata}
              loading={dbloaderSatus}
              setLoading={setDbloaderStatusp}
            />
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
              marginTop: "1rem",
            }}
          >
            <Button
              color="green"
              className={`btn linear-gradient yr-submitbtn btn-sm ${styles.button}`}
              onClick={() => {
                handleSaveConnection();
              }}
            >
              Save New Connection
            </Button>
          </div>

          <div style={{ marginTop: "2rem" }}>
            <button className={`${styles.linkButton}`}>
              Data Layer Listing
            </button>
            <ConnectionList
              onEdit={onEditApiEndpont}
              toolapiendpoint={toolapiendpoint}
              loadToolApiendpoint={loadToolApiendpoint}
              conloaderSatus={conloaderSatus}
              setConloaderStatus={setConloaderStatus}
              resetCOnnectform={resetCOnnectform}
            />
          </div>
          <div
            style={{ marginTop: "2rem" }}
            className={`${styles.datalayerTable}`}
          >
            <a
              onClick={() => {
                setmodalStatusandcleardata(!modalStatus);
              }}
            >
              <button className={`${styles.linkButton}`}>
                <i className="fas fa-plus"></i>
                Add new data connection
              </button>
            </a>

            <DatabaseListing
              databases={databases}
              open={modalStatus}
              onClose={() => setmodalStatus(false)}
              onOpen={() => setmodalStatus(true)}
              setDatabases={setDatabases}
              setinitFormdata={setinitFormdata}
              loading={dbloaderSatus}
              setLoading={setDbloaderStatus}
            />
          </div>
        </DataProvider>
      </div>
    </>
  );
};

export default Dataconnectionwrapper;
